import { ref, watch } from 'vue'
import { type Settings, DEFAULT_SETTINGS } from '@/components/settingsModels'

const settings = ref<Settings>(loadSettings())

function loadSettings(): Settings {
  const stored = localStorage.getItem('settings')
  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      return {
        ...DEFAULT_SETTINGS,
        ...parsed,
        simpleReaction: { ...DEFAULT_SETTINGS.simpleReaction, ...parsed.simpleReaction },
        discriminationReaction: { ...DEFAULT_SETTINGS.discriminationReaction, ...parsed.discriminationReaction },
        hardwareTest: { ...DEFAULT_SETTINGS.hardwareTest, ...parsed.hardwareTest }
      }
    } catch (e) {
      console.error('Fehler beim Laden der Einstellungen:', e)
    }
  }
  return JSON.parse(JSON.stringify(DEFAULT_SETTINGS))
}

watch(
  settings,
  (newSettings) => {
    localStorage.setItem('settings', JSON.stringify(newSettings))
  },
  { deep: true }
)

export function useSettings() {
  return {
    settings
  }
}
